module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-1-photo-7-5132ccdead7c679f26ac060d4b8097c0.webp";